exports.components = {
  "component---src-layouts-pages-page-header-footer-tsx": () => import("./../../../src/layouts/pages/page-header-footer.tsx" /* webpackChunkName: "component---src-layouts-pages-page-header-footer-tsx" */)
}

